<template>
    <div>
        <div style="height: 4px; " :style="{backgroundColor: colorHex.hex}"></div>
        <img class="pt_logo" style="margin: 30px auto 30px auto; display: block; height: 40px;" :src="logoUrl" v-if="logoUrl">
        <p style="margin: 20px auto 10px auto; display: block; text-align: center; font-size: 20px; font-weight: 600;" :src="logoUrl" v-if="!logoUrl">{{ $store.state.dash.viewData.business.businessName }}</p>
        <p style="padding: 0 5px; margin: 15px 0; font-size: 16px;">[Customer greeting if applicable],</p>
        <p style="padding: 0 5px; margin: 15px 0 20px 0; font-size: 16px; max-width:800px;">{{ changePrompt ? changePrompt : $store.getters['dash/currentLanguagePack'].emailInviteIntro.replace('[businessname]', $store.state.dash.viewData.business.businessInfo.businessName) }}</p>        
        <div style="min-width: 310px; padding: 50px 0; background-color: #F7F7F7; font-family: 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif';text-align: center;">          
          <p style="line-height: 1.3; max-width: 400px; font-size: 24px; text-align: center; margin: 0 auto;">{{ $store.getters['dash/currentLanguagePack'].starQuestion.replace('[businessname]', $store.state.dash.viewData.business.businessInfo.businessName) }}</p>
          <div style="position: relative; display: inline-block; margin: 20px 0;">
          <table>
              <tbody>                  
              <tr class="stars">
              <td class="star" valign="middle"
              style="display:inline-block;height:56px;width:56px;font-family:'Helvetica Neue', Helvetica, Arial, sans-serif;font-weight:bold;color:#636363;text-indent:0;background:url('https://firebasestorage.googleapis.com/v0/b/feedbacklink-fbl.appspot.com/o/Email%20resources%2Fcutout.png?alt=media&token=1ebd83e6-97ec-4c2c-856a-488c182f426a') no-repeat 0 0 / 100% auto"
              width="56" height="56"><a aria-label="1" rel="nofollow"
                  style="display:block;text-decoration:none"><img alt="1/5"
                      src="https://firebasestorage.googleapis.com/v0/b/feedbacklink-fbl.appspot.com/o/Email%20resources%2Fwhite.png?alt=media&token=d92e747e-47f6-42e6-a93b-05c54abf7cc4"
                      style="outline:0;text-decoration:none;-ms-interpolation-mode:bicubic;display:block;height:56px;width:56px;font-family:'Helvetica Neue', Helvetica, Arial, sans-serif;font-weight:bold;color:#636363;text-indent:0;border:0"
                      width="56" height="56" /></a></td><td class="star" valign="middle"
                      style="display:inline-block;height:56px;width:56px;font-family:'Helvetica Neue', Helvetica, Arial, sans-serif;font-weight:bold;color:#636363;text-indent:0;background:url('https://firebasestorage.googleapis.com/v0/b/feedbacklink-fbl.appspot.com/o/Email%20resources%2Fcutout.png?alt=media&token=1ebd83e6-97ec-4c2c-856a-488c182f426a') no-repeat 0 0 / 100% auto"
              width="56" height="56"><a aria-label="2" rel="nofollow"
              
                  style="display:block;text-decoration:none"><img alt="2/5"
                      src="https://firebasestorage.googleapis.com/v0/b/feedbacklink-fbl.appspot.com/o/Email%20resources%2Fwhite.png?alt=media&token=d92e747e-47f6-42e6-a93b-05c54abf7cc4"
                      style="outline:0;text-decoration:none;-ms-interpolation-mode:bicubic;display:block;height:56px;width:56px;font-family:'Helvetica Neue', Helvetica, Arial, sans-serif;font-weight:bold;color:#636363;text-indent:0;border:0"
                      width="56" height="56" /></a></td><td class="star" valign="middle"
              style="display:inline-block;height:56px;width:56px;font-family:'Helvetica Neue', Helvetica, Arial, sans-serif;font-weight:bold;color:#636363;text-indent:0;background:url('https://firebasestorage.googleapis.com/v0/b/feedbacklink-fbl.appspot.com/o/Email%20resources%2Fcutout.png?alt=media&token=1ebd83e6-97ec-4c2c-856a-488c182f426a') no-repeat 0 0 / 100% auto"
              width="56" height="56"><a aria-label="3" rel="nofollow"
              
                  style="display:block;text-decoration:none"><img alt="3/5"
                      src="https://firebasestorage.googleapis.com/v0/b/feedbacklink-fbl.appspot.com/o/Email%20resources%2Fwhite.png?alt=media&token=d92e747e-47f6-42e6-a93b-05c54abf7cc4"
                      style="outline:0;text-decoration:none;-ms-interpolation-mode:bicubic;display:block;height:56px;width:56px;font-family:'Helvetica Neue', Helvetica, Arial, sans-serif;font-weight:bold;color:#636363;text-indent:0;border:0"
                      width="56" height="56" /></a></td><td class="star" valign="middle"
              style="display:inline-block;height:56px;width:56px;font-family:'Helvetica Neue', Helvetica, Arial, sans-serif;font-weight:bold;color:#636363;text-indent:0;background:url('https://firebasestorage.googleapis.com/v0/b/feedbacklink-fbl.appspot.com/o/Email%20resources%2Fcutout.png?alt=media&token=1ebd83e6-97ec-4c2c-856a-488c182f426a') no-repeat 0 0 / 100% auto"
              width="56" height="56"><a aria-label="4" rel="nofollow"
              
                  style="display:block;text-decoration:none"><img alt="4/5"
                      src="https://firebasestorage.googleapis.com/v0/b/feedbacklink-fbl.appspot.com/o/Email%20resources%2Fwhite.png?alt=media&token=d92e747e-47f6-42e6-a93b-05c54abf7cc4"
                      style="outline:0;text-decoration:none;-ms-interpolation-mode:bicubic;display:block;height:56px;width:56px;font-family:'Helvetica Neue', Helvetica, Arial, sans-serif;font-weight:bold;color:#636363;text-indent:0;border:0"
                      width="56" height="56" /></a></td><td class="star" valign="middle"
              style="display:inline-block;height:56px;width:56px;font-family:'Helvetica Neue', Helvetica, Arial, sans-serif;font-weight:bold;color:#636363;text-indent:0;background:url('https://firebasestorage.googleapis.com/v0/b/feedbacklink-fbl.appspot.com/o/Email%20resources%2Fcutout.png?alt=media&token=1ebd83e6-97ec-4c2c-856a-488c182f426a') no-repeat 0 0 / 100% auto"
              width="56" height="56"><a aria-label="5" rel="nofollow"
              
                  style="display:block;text-decoration:none"><img alt="5/5"
                      src="https://firebasestorage.googleapis.com/v0/b/feedbacklink-fbl.appspot.com/o/Email%20resources%2Fwhite.png?alt=media&token=d92e747e-47f6-42e6-a93b-05c54abf7cc4"
                      style="outline:0;text-decoration:none;-ms-interpolation-mode:bicubic;display:block;height:56px;width:56px;font-family:'Helvetica Neue', Helvetica, Arial, sans-serif;font-weight:bold;color:#636363;text-indent:0;border:0"
                      width="56" height="56" /></a></td>
              </tr>
              </tbody>
              </table>
          </div>        
      </div>
      <div v-if="!$store.getters['dash/isAgencyClientParentEID']" style="text-align: right; background: white; font-family: 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif'; border-top: 1px solid #DFDFDF;"><a style="color: gray; text-decoration: none; padding: 0 6px; margin: 10px 0 0 0; display: inline-block; font-size: 14px;" target="_blank">Powered by Feedback Link</a><a style="color: gray; text-decoration: none; font-size: 14px; padding: 0 6px; margin: 10px 0 0 0; display: inline-block; border-left: 1px solid gray;"
            target="_blank">Privacy</a>
        </div>
    </div>
</template>


<script>

export default {
    props: {
     changePrompt: {
            type: [String, Boolean],
            default: false
      },
      providedHex: {
        type: [Boolean, Object],
        default: false
      }
    },
    computed: {
        colorHex() {
            return this.providedHex ? 
              this.providedHex : this.$store.state.dash.viewData.business.publicFeedbackDetail.appearanceInfo.backgroundHex
        }
    }
}

</script>


<style>
      .stars:hover .star,
      .stars.is-hover .star {
          background-color: #ffd153 !important
      }

      .star,
      .star:hover+.star,
      .star.is-hover+.star,
      .star:hover+.star+.star,
      .star.is-hover+.star+.star,
      .star:hover+.star+.star+.star,
      .star.is-hover+.star+.star+.star,
      .star:hover+.star+.star+.star+.star,
      .star.is-hover+.star+.star+.star+.star {
          background-color: transparent !important
      }

      .stars:hover img,
      .stars.is-hover img {
          opacity: 0 !important
      }

      .star img,
      .star:hover+.star img,
      .star.is-hover+.star img,
      .star:hover+.star+.star img,
      .star.is-hover+.star+.star img,
      .star:hover+.star+.star+.star img,
      .star.is-hover+.star+.star+.star img,
      .star:hover+.star+.star+.star+.star img,
      .star.is-hover+.star+.star+.star+.star img {
          opacity: 1 !important
      }

      .star img {
          line-height: 20px;
          font-size: 20px;
          display: block;

      }
            
      .star img {
        line-height: 16px;
        font-size: 16px
    }
</style>